import { fireClearCodeEvent, goToPage } from "../../../editor/events";

import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import { toggleShowStacksDuringDemoMode } from "../../../messageBus";
import { typeSomeText } from "../../common";
import TourStepContent from "../../wrapper";

const stories: (arg0: string) => StepType[] = (hostId: string) => [
	{
		selector: ".author-root",
		position: "center",
		content: () => (
			<TourStepContent description={() => <strong>{text.tourSteps.storiesTitle}</strong>} />
		),
		action: () => {
			goToPage(hostId, "QP", 1);
			fireClearCodeEvent();
			typeSomeText({ text: " " });
		},
	},

	{
		selector: "#control-stories",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesWeCallStories} />
		),
	},
	{
		selector: "#control-stories",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesClickToOpenOrig} />
		),
		action: () => toggleShowStacksDuringDemoMode(hostId),
	},
	{
		selector: "#stories",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesViewAllOrig} />
		),
	},
	{
		selector: "#link-to-help",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesFindHelp} />
		),
	},
	{
		selector: "#stories",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesOpenHelp} />
		),
		action: () => {
			const toggle = document.getElementById("link-to-help");
			toggle?.click();
		},
	},
	{
		selector: ".styled-stacks",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesLayoutExamples} />
		),
	},
	{
		selector: "#stories",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesOpenFilters} />
		),
		action: () => {
			const toggle = document.getElementById("link-to-filters");
			toggle?.click();
		},
	},
	{
		selector: ".file-control.rename",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesRename} />
		),
	},
	{
		selector: ".file-control.trash",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesDelete} />
		),
	},
	{
		selector: ".file-link",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesClickToEditOrig} />
		),
	},
	{
		selector: ".story-modal--controls",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesCreateOrClose} />
		),
	},
	{
		selector: ".story-modal--controls",
		content: () => (
			<TourStepContent description={() => text.tourSteps.storiesCreateOrClose} />
		),
		action: () => toggleShowStacksDuringDemoMode(hostId),
	},
];

export default stories;
